import api from './api'

export const knowledgebaseBaseUrl = '/api/v1/knowledgebase'

export async function getRelatedDefinitions() {
  const resp = await api.get(`${knowledgebaseBaseUrl}`)
  return resp.data
}

export async function getRelatedDefinition(slug) {
  const resp = await api.get(`${knowledgebaseBaseUrl}/${slug}`)
  return resp.data
}
